<template>
    <div class="img-icon">
        <div v-if="url === 'XLS' || url === 'XLSX'"><img style="width:100%;" src="@/assets/img/icons/xls.svg" alt=""></div>
        <div v-else-if="url === 'DOCX' || url === 'DOC'" ><img style="width:100%;" src="@/assets/img/icons/doc.svg" alt=""></div>
        <div v-else-if="url === 'PDF'" ><img style="width:100%;" src="@/assets/img/icons/pdf.svg" alt=""></div>
        <div v-else-if="url === 'PNG'" ><img style="width:100%;" src="@/assets/img/icons/png.svg" alt=""></div>
        <div v-else-if="url === 'JPG'" ><img style="width:100%;" src="@/assets/img/icons/jpg.svg" alt=""></div>
        <div v-else-if="url === '3DS'" ><img style="width:100%;" src="@/assets/img/icons/3ds.svg" alt=""></div>
        <div v-else-if="url === 'AI'" ><img style="width:100%;" src="@/assets/img/icons/ai.svg" alt=""></div>
        <div v-else-if="url === 'BIN'" ><img style="width:100%;" src="@/assets/img/icons/bin.svg" alt=""></div>
        <div v-else-if="url === 'DWG'" ><img style="width:100%;" src="@/assets/img/icons/dwg.svg" alt=""></div>
        <div v-else-if="url === 'EPS'" ><img style="width:100%;" src="@/assets/img/icons/eps.svg" alt=""></div>
        <div v-else-if="url === 'GIF'" ><img style="width:100%;" src="@/assets/img/icons/gif.svg" alt=""></div>
        <div v-else-if="url === 'ISO'" ><img style="width:100%;" src="@/assets/img/icons/iso.svg" alt=""></div>
        <div v-else-if="url === 'MOV'" ><img style="width:100%;" src="@/assets/img/icons/mov.svg" alt=""></div>
        <div v-else-if="url === 'MP3'" ><img style="width:100%;" src="@/assets/img/icons/mp3.svg" alt=""></div>
        <div v-else-if="url === 'MP4'" ><img style="width:100%;" src="@/assets/img/icons/mp4.svg" alt=""></div>
        <div v-else-if="url === 'OTF'" ><img style="width:100%;" src="@/assets/img/icons/otf.svg" alt=""></div>
        <div v-else-if="url === 'PPT'" ><img style="width:100%;" src="@/assets/img/icons/ppt.svg" alt=""></div>
        <div v-else-if="url === 'PSD'" ><img style="width:100%;" src="@/assets/img/icons/psd.svg" alt=""></div>
        <div v-else-if="url === 'RTF'" ><img style="width:100%;" src="@/assets/img/icons/rtf.svg" alt=""></div>
        <div v-else-if="url === 'SVG'" ><img style="width:100%;" src="@/assets/img/icons/svg.svg" alt=""></div>
        <div v-else-if="url === 'TTF'" ><img style="width:100%;" src="@/assets/img/icons/ttf.svg" alt=""></div>
        <div v-else-if="url === 'TXT'" ><img style="width:100%;" src="@/assets/img/icons/txt.svg" alt=""></div>
        <div v-else-if="url === 'ZIP'" ><img style="width:100%;" src="@/assets/img/icons/zip.svg" alt=""></div>
        <div v-else><img style="width:100%;" src="@/assets/img/icons/file2.svg" alt=""></div>    </div>
</template>

<script>
  export default {
    name: 'icon-img',
    props:{
      url: String
    }
  }
</script>

<style lang="scss" scoped>

</style>
